import { render, staticRenderFns } from "./RequesterOrganizationSync.vue?vue&type=template&id=bbf8fa70&scoped=true"
import script from "./RequesterOrganizationSync.vue?vue&type=script&lang=js"
export * from "./RequesterOrganizationSync.vue?vue&type=script&lang=js"
import style0 from "./RequesterOrganizationSync.vue?vue&type=style&index=0&id=bbf8fa70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf8fa70",
  null
  
)

export default component.exports